import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowTableRow: Components<Theme>['MuiTableRow'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      borderColor: 'inherit',
      // works as link
      ...(!!ownerState?.onClick && {
        cursor: 'pointer',
      }),
      // selected styl
      '&.Mui-selected': {
        backgroundColor: theme.palette.surface.primary,
      },
      // hover
      '&.MuiTableRow-hover': {
        '&:hover': {
          backgroundColor: theme.palette.surface.primary,
        },
        '&.Mui-selected:hover': {
          backgroundColor: theme.palette.surface.primary,
        },
      },
    }),
  },
};
